import axios from "axios";
import { getToken } from "../services/auth";

export default axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
});

export const axiosBackend = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});